<template>
    <b-list-group-item class="post-item">
        <b-row><b-col><span  class="post-title">{{ model.title }}</span></b-col></b-row>
        <b-row><b-col><span  class="post-content"><app-long-text :id="'home-post-item-' + index" :maxLength="50" :text="model.content" /></span></b-col></b-row>
        <b-row class="mt-1">
            <b-col cols="6">
                <b-avatar variant="info" :src="model.createdBy != null ? model.createdBy.image : ''" class="mr-2"></b-avatar><span class="post-owner">{{ model.createdBy }}</span>
            </b-col>
            <b-col cols="6">
                <span class="float-right mt-1"><span class="post-date">{{ model.createdDate | moment('DD-MMM-YYYY')}}</span></span>
            </b-col>
        </b-row>
    </b-list-group-item>
</template>
<script>
export default {
    props :
    {
        model : {
            default: {},
            type: Object
        },
        index : {
            default: 0,
            type: [Number,String]
        }
    }
}
</script>